"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDurationTime = void 0;
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../../constants");
const prepareTime = (config) => Object.keys(config)
    .filter((key) => config[key])
    .map((key) => `${config[key]} ${key}${config[key] > 1 ? 's' : ''}`)
    .join(' ');
const formatDurationTime = ({ durationValue, unit = constants_1.UNIT_OF_TIME.milliseconds, emptyValue = constants_1.EMPTY_TEXT.dash, } = {}) => {
    let value = '';
    if (!durationValue) {
        value = emptyValue;
    }
    else {
        const d = moment_1.default.duration(Number(durationValue), unit);
        if (d.asMilliseconds() < 1000) {
            value = '1 second';
        }
        else {
            value = prepareTime({
                day: d.days(),
                hour: d.hours(),
                minute: d.minutes(),
                second: d.seconds(),
            });
        }
    }
    return value;
};
exports.formatDurationTime = formatDurationTime;
//# sourceMappingURL=formatDurationTime.js.map